import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getMachineTransfers(options = {}) {
	return _apiRequestWrap(
		ModulesMap.MACHINE_TRANSFERS,
		ModulesConfigMap[ModulesMap.MACHINE_TRANSFERS].GET_TRANSFERS,
		options
	)
}

function _createMachineTransfer(options = {}) {
	return _apiRequestWrap(
		ModulesMap.MACHINE_TRANSFERS,
		ModulesConfigMap[ModulesMap.MACHINE_TRANSFERS].CREATE_TRANSFER,
		options
	)
}

function _getMachineTransfer(options = {}) {
	return _apiRequestWrap(
		ModulesMap.MACHINE_TRANSFERS,
		ModulesConfigMap[ModulesMap.MACHINE_TRANSFERS].GET_TRANSFER,
		options
	)
}

function _patchMachineTransfer(options = {}) {
	return _apiRequestWrap(
		ModulesMap.MACHINE_TRANSFERS,
		ModulesConfigMap[ModulesMap.MACHINE_TRANSFERS].PATCH_TRANSFER,
		options
	)
}

function _putMachineTransfer(options = {}) {
	return _apiRequestWrap(
		ModulesMap.MACHINE_TRANSFERS,
		ModulesConfigMap[ModulesMap.MACHINE_TRANSFERS].PUT_TRANSFER,
		options
	)
}

function _deleteMachineTransfer(options = {}) {
	return _apiRequestWrap(
		ModulesMap.MACHINE_TRANSFERS,
		ModulesConfigMap[ModulesMap.MACHINE_TRANSFERS].DELETE_TRANSFER,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.MACHINE_TRANSFERS].GET_TRANSFER]: _getMachineTransfers,

	[ModulesConfigMap[ModulesMap.MACHINE_TRANSFERS].CREATE_TRANSFER]: _createMachineTransfer,
	[ModulesConfigMap[ModulesMap.MACHINE_TRANSFERS].GET_TRANSFER]: _getMachineTransfer,
	[ModulesConfigMap[ModulesMap.MACHINE_TRANSFERS].PATCH_TRANSFER]: _patchMachineTransfer,
	[ModulesConfigMap[ModulesMap.MACHINE_TRANSFERS].PUT_TRANSFER]: _putMachineTransfer,
	[ModulesConfigMap[ModulesMap.MACHINE_TRANSFERS].DELETE_TRANSFER]: _deleteMachineTransfer,
}